var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article_box"},[_c('h1',{staticClass:"article_title"},[_vm._v(_vm._s(_vm.articleArr.title))]),_vm._v(" "),_c('viewer',{attrs:{"images":_vm.imgArr}},[_c('div',{staticClass:"article_content",domProps:{"innerHTML":_vm._s(_vm.articleArr.content)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45799d07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/article.vue
// module id = null
// module chunks = 